import { KYMW0001OutputModel } from "../../../kymw00/kymw0001/vo/kymw0001-output.model";
import { KYMW0002OutputModel } from "../../../kymw00/kymw0002/vo/kymw0002-output.model";

/**
 * 商品検索用VOクラス
 *
 * @export KYMW0300InputModel
 * @class KYMW0300InputModel
 */
export class KYMW0300InputModel {

  //// 通常検索タブ
  // 商品関連条件
  /** Pコード */
  public pcode: string = <string>'';
  /** アイテムコード */
  public itemCode: string = <string>'';
  /** 使用しない：仕様書コード */
  public ebaseSpecCode: string = <string>'';
  /** 使用しない：データ種別 */
  public dataType: string = <string>'';
  /** JANコード */
  public janCode: string = <string>'';
  /** メーカ名 */
  public makerName: string = <string>'';
  /** 商品案内用商品名 */
  public guideGoodsNameList: Array<any> = new Array<any>();
  /** 商品案内用規格名 */
  public guideStandardNameList: Array<any> = new Array<any>();
  /** タグ */
  public tagId: Array<string> = new Array<string>();
  /** タグ検索方法 */
  public tagSearchType: string = <string>'AND';
  /** タグ再表示用 */
  public tagOutput: KYMW0002OutputModel;
  /** 商品マーク */
  public goodsMark: Array<string> = new Array<string>();
  /** 商品マーク検索方法 */
  public goodsMarkSearchType: string = <string>'OR';
  /** 商品マーク再表示用 */
  public goodsMarkOutput: KYMW0001OutputModel;
  /** 取扱終了商品を含む */
  public dataKbnFlg: boolean = <boolean>false;
  /** 商品区分(空文字:全ての商品、1:ダミー商品) */
  public goodsDiv: string = <string>'';
  /** 取扱可能生協 */
  public coopCodeList: Array<any> = new Array<any>();
  /** バイヤーコード */
  public buyerCode: string = <string>'';
  /** 登録レベル */
  public admitStatus: string = <string>'';
  /** 使用しない：商品マスタ登録日チェック */
  public registDateCheck: boolean = <boolean>false;
  /** 商品マスタ登録日From */
  public registDateFrom: string = <string>'';
  /** 商品マスタ登録日To */
  public registDateTo: string = <string>'';
  /** 使用しない：商品マスタ更新日チェック */
  public updateDateCheck: boolean = <boolean>false;
  /** 商品マスタ更新日From */
  public updateDateFrom: string = <string>'';
  /** 商品マスタ更新日To */
  public updateDateTo: string = <string>'';
  
  // 部門分類条件
  /** 部門コード */
  public classCode: string = <string>'';
  /** 中分類コード */
  public middleClassCode: string = <string>'';
  /** 小分類コード */
  public smallClassCode: string = <string>'';

  // 取引先分類条件
  /** 発注先コード */
  public ordrClientCode: string = <string>'';
  /** 発注先名称 */
  public ordrClientKanji: string = <string>'';
  /** 支払先コード */
  public payeeClientCode: string = <string>'';
  /** 支払先名称 */
  public payeeClientKanji: string = <string>'';

  // 企画関連条件
  /** 媒体 */
  public mediumType: string = <string>'';
  /** 受注コード */
  public orderCode: string = <string>'';
  /** 企画回再表示用 */
  public catalogId: string = <string>'';
  /** 特集コード */
  public specialFeature: string = <string>'';
  /** 企画マーク */
  public catalogCode: Array<string> = new Array<string>();
  /** 企画マーク検索方法 */
  public catalogCodeSearchType: string = <string>'OR';
  /** 企画マーク再表示用 */
  public catalogMarkOutput: KYMW0001OutputModel;
  /** ページNO */
  public pageNo: Array<string> = new Array<string>();
  /** ページ再表示用 */
  public pageInput: string = '';

  // 業態区分条件
  /** デイリー */
  public duties: Array<string> = new Array<string>();
  // 以下3つの変数は使用しない。他画面でデイリーを使用する場合は上記のdutiesを使用し、
  // ウィークリー、スポットは本画面で選択できないため必ずfalseが格納される
  /**  使用しない：業態区分（ウィークリー） */
  public dutiesFormWeekly: boolean = <boolean>false;
  /**  使用しない：業態区分（デイリー） */
  public dutiesFormDailyList: Array<any> = new Array<any>();
  /**  使用しない：業態区分（スポット） */
  public dutiesFormSpot: boolean = <boolean>false;

  //// Ｐコードリスト検索タブ
  /** Ｐコードリスト */
  public pcodeList: Array<any> = new Array<any>();
  /** 取扱終了商品を含む（Pコードリスト） */
  public dataKbnFlg_pcodeList = Boolean(false);

  //// アイテムコードリスト検索タブ
  /** アイテムコードリスト */
  public itemCodeList: Array<any> = new Array<any>();
  /** 取扱終了商品を含む（アイテムコードリスト） */
  public dataKbnFlg_itemCodeList = Boolean(false);

  // フラグ
  /** 検索区分（0:通常検索、1:リスト検索（Pコード）、2:リスト検索（アイテムコード）） */
  public searchKbn: number = <number>0;
  /** 企画検索フラグ（0:非表示、1:表示） */
  public catalogSearchFlg: number = <number>1;

}




